import { render, staticRenderFns } from "./LiefengTree.vue?vue&type=template&id=cc46c2a2&scoped=true&"
import script from "./LiefengTree.vue?vue&type=script&lang=js&"
export * from "./LiefengTree.vue?vue&type=script&lang=js&"
import style0 from "./LiefengTree.vue?vue&type=style&index=0&id=cc46c2a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc46c2a2",
  null
  
)

export default component.exports